<template>
  <button
    type="button"
    class="flex h-4 w-7 shrink-0 rounded-full border"
    tabindex="0"
    :disabled
    :class="[
      inputValue
        ? 'bg-switch-bgr-active hover:bg-switch-bgr-active-hover border-switch-bdr-active hover:border-switch-bdr-active-hover'
        : 'bg-switch-bgr-default hover:bg-switch-bgr-hover border-switch-bdr-default hover:border-switch-bdr-hover',
      disabled ? 'bg-switch-bgr-disabled! border-switch-bdr-disabled! cursor-not-allowed' : 'cursor-pointer',
    ]"
    @click="onClick"
  >
    <div
      class="bg-fgr-inverse shadow-toggle size-3.5 rounded-full transition-all duration-300"
      :class="[inputValue ? 'ms-[13px]' : 'ms-0']"
    />
  </button>
</template>

<script setup lang="ts">
  const props = withDefaults(
    defineProps<{
      name?: string;
      selected?: boolean;
      disabled?: boolean;
      parentClicked?: boolean;
    }>(),
    {
      name: "",
      selected: false,
      disabled: false,
      parentClicked: false,
    }
  );

  defineModel<boolean>();

  const onClick = () => {
    if (props.disabled) return;
    setValue();
  };

  watch(
    () => props.parentClicked,
    () => {
      setValue();
    }
  );

  const { value: inputValue } = useField(() => props.name, undefined, {
    type: "checkbox",
    checkedValue: true,
    uncheckedValue: false,
    syncVModel: props.name ? false : true,
    controlled: !!props.name,
  });

  const setValue = () => {
    if (props.disabled) return;
    inputValue.value = !inputValue.value;
  };
</script>
